export default __webpack_public_path__ + "resmi_degil_kaybetti.png";